// VueInfinitePager.vue
<template>
  <div class="vue-infinite-pager" v-if="totalPages > 1">
    <button
      v-if="currentPage < totalPages - 1"
      v-on:click.stop.prevent="goToPage('next')"
      type="primary"
      class="button rounded blue"
      :loading="true"
    >
      {{ labelMore }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    totalPages: {
      default: 0,
    },
  },
  data() {
    return {
      currentPage: 0,
    };
  },
  watch: {
    currentPage(newValue) {
      this.$emit("vuePagerCurrentPageUpdate", newValue);
    },
  },
  computed: {
    labelMore() {
      return "Show more";
    },
  },
  methods: {
    goToNextPage() {
      this.goToPage("next");
    },
    goToPage(page) {
      if (page === "next") {
        if (this.currentPage < this.totalPages - 1) {
          this.currentPage++;
        }
      } else if (page === "previous") {
        if (this.currentPage > 0) {
          this.currentPage--;
        }
      } else {
        this.currentPage = page;
      }
    },
  },
};
</script>
